/*
JS Components
*/

// import "./forms/input-file";
import "./site-header/alert/site-alert";
import "./site-header/navigation--obscurable.js";
// import './audio-player/index';
// import './lazy-iframe/index';
import "./forms/jquery-validate-error-adjustments";
import "./forms/category-and-product-selector";
import "./forms/single-address-validation";
import "./forms/single-line-address-autosuggest";
import "./forms/tooltip";
import "./forms/increase-decrease";
import "./forms/address-validation";
import "./forms/suburb-validation";
import "./forms/suburb-postcode-autosuggest";
import "./forms/suburb-postcode-noaddress-autosuggest";
import "./forms/product-additional-features";
import "./forms/postcode-search";
import "./modal/index";
import "./sticky-navigation/index";
import "./buttons/analytics-trigger";
import "./dropdown/index";
import "./banner-scroll/index";



// WEBPACK FOOTER //
// ./client/src/core/components/index.js